<template>
  <CustomButton
    v-if="currentPage < totalPages"
    type="primary"
    class="mt-10 py-3 mb-28"
    :text="$t('Load more')"
    @click="onLoadMore"
  />
</template>

<script lang="ts">

import { PAGINATION_DEFAULT_RESULTS_LIMIT } from '~~/constants/pagination';

export default defineComponent({
  name: 'PaginationReviews',

  props: {
    totalResultsAmount: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      default: PAGINATION_DEFAULT_RESULTS_LIMIT,
    },
  },
  emits: ['onLoadMore'],
  setup(props, { emit }) {

    const {
      currentPage,
      totalPages,
      getLoadMoreParams,
    } = usePagination(props.totalResultsAmount, props.perPage);

    const onLoadMore = () => {

      const pageChangeParams = getLoadMoreParams();
      emit('onLoadMore', pageChangeParams);
    
    };

    return {
      currentPage,
      totalPages,
      onLoadMore,
    };
  
  },
});

</script>
